<template>
  <div class="modal right fade" :id="objectModalName.incident" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog" role="document">
<!--      <button type="button" class="close md-close" @click="closeWarning('#'+objectModalName.incident)" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
      <div class="modal-content">

        <div class="modal-header">
          <button type="button" class="close xs-close" data-dismiss="modal" @click="closeWarning('#'+objectModalName.incident)">×</button>
          <div class="row w-100">
            <div class="col-md-7 account d-flex">
              <div class="company_img">
                <img src="@/assets/img/c-logo.png" alt="User" class="img-fluid" />
              </div>
              <div>
                <p class="mb-0">Vorfall
                  <a href="#" @click.prevent="setEdit(!edit)"><span class="lock"><i class="fa fa-pencil" aria-hidden="true" v-show="!edit"></i><i class="fa fa-lock" aria-hidden="true" v-show="edit"></i></span></a>
                </p>
                <span class="modal-title">Datenschutzvorfall am {{incident.datetime}}</span>
              </div>
            </div>
          </div>

        </div>

        <div class="modal-body">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h4>Allgemein</h4>

                  <div class="form-group row">
                    <div class="col-12">
                      <label class="col-form-label">Beschreibung des Sicherheitsvorfalls / Datenpanne<span class="text-danger">*</span></label>
                      <p class="mt-1 fs-14" v-if="incident.id && !edit">{{incident.description}}</p>
                      <textarea class="form-control" v-show="!incident.id || edit"  v-model="incident.description" placeholder="Beschreibung" autocomplete="off" />
                      <span class="error-message text-danger" v-show="v$.incident.description.$errors.length>0">{{ $t('required_field') }}</span>
                    </div>
                  </div> <!-- end row -->

                  <div class="form-group row">
                    <div class="col-6">
                      <label class="col-form-label">Datum und Zeitpunkt der Kenntnisnahme<span class="text-danger">*</span></label>
                      <p class="mt-1 fs-14" v-if="incident.id && !edit">{{incident.datetime}}</p>
                      <dateTimePicker v-model="incident.datetime" :config="datetimeOptions" v-show="!incident.id || edit"></dateTimePicker>
                      <span class="error-message text-danger" v-show="v$.incident.datetime.$errors.length>0">{{ $t('required_field') }}</span>
                    </div>
                    <div class="col-6">
                      <label class="col-form-label">Meldender / Wer hat die Panne festgestellt<span class="text-danger">*</span></label>
                      <p class="mt-1 fs-14" v-if="incident.id && !edit">{{incident.reporter}}</p>
                      <input class="form-control" v-show="!incident.id || edit" v-model="incident.reporter" placeholder="Meldender" autocomplete="off">
                      <span class="error-message text-danger" v-show="v$.incident.reporter.$errors.length>0">{{ $t('required_field') }}</span>
                    </div>
                  </div> <!-- end row -->

                  <div class="form-group row">
                    <div class="col-12">
                      <label class="col-form-label">Mögliche Konsequenzen für die Betroffenen</label>
                      <p class="mt-1 fs-14" v-if="incident.id && !edit">{{incident.consequence}}</p>
                      <input class="form-control" v-show="!incident.id || edit"  v-model="incident.consequence" placeholder="Konsequenzen" autocomplete="off">
                    </div>
                  </div> <!-- end row -->

                  <div class="form-group row">
                    <div class="col-6 dkl-checkbox">
                      <input class="form-check-input" type="checkbox" :readonly="!incident.id || !edit" v-model="incident.inform_lda" autocomplete="off">
                      <label class="form-check-label" for="data_processor">Meldpflicht</label>
                    </div>
                    <div class="col-6">
                      <label class="col-form-label">Meldung an die Aufsichtsbehörde am</label>
                      <p class="mt-1 fs-14" v-if="incident.id && !edit">{{incident.date_inform_lda}}</p>
                      <dateTimePicker v-model="incident.date_inform_lda" :config="dateOptions" v-show="!incident.id || edit"></dateTimePicker>
                    </div>
                  </div> <!-- end row -->

                  <div class="form-group row">
                    <div class="col-6 dkl-checkbox">
                      <input class="form-check-input" type="checkbox" :readonly="!incident.id || !edit" v-model="incident.inform_affected" autocomplete="off">
                      <label class="form-check-label" for="data_processor">Information der Betroffenen</label>
                    </div>
                    <div class="col-6">
                      <label class="col-form-label">Information der Betroffenen am sowie Meldeweg</label>
                      <p class="mt-1 fs-14" v-if="incident.id && !edit">{{incident.inform_affected_remarks}}</p>
                      <input class="form-control" v-show="!incident.id || edit"  v-model="incident.inform_affected_remarks" placeholder="Meldung am" autocomplete="off">
                    </div>
                  </div> <!-- end row -->
                  <div class="form-group row">
                    <div class="col-12">
                      <label class="col-form-label">Maßnahmen Beschreibung</label>
                      <p class="mt-1 fs-14" v-if="incident.id && !edit">{{incident.followups}}</p>
                      <textarea class="form-control" rows="6" v-show="!incident.id || edit"  v-model="incident.followups" placeholder="Maßnahmen Beschreibung" autocomplete="off" />
                    </div>
                  </div> <!-- end row -->

                  <div class="form-group row">
                    <div class="col-6">
                      <label class="col-form-label">Prozess Verantwortlicher</label>
                      <p class="mt-1 fs-14" v-if="incident.id && !edit">{{incident.responsible}}</p>
                      <input class="form-control" v-show="!incident.id || edit"  v-model="incident.responsible" placeholder="Meldung am" autocomplete="off">
                    </div>
                    <div class="col-6">
                      <label class="col-form-label">Bemerkung</label>
                      <p class="mt-1 fs-14" v-if="incident.id && !edit">{{incident.remarks}}</p>
                      <textarea class="form-control" v-show="!incident.id || edit"  v-model="incident.remarks" placeholder="Meldung am" autocomplete="off" />
                    </div>
                  </div> <!-- end row -->

                  <h4 class="dkl-h4">Maßnahmen<a class="dkl-btn btn-md rounded-circle" @click.prevent="$emit('openTaskModal')" v-show="incident.id" href="#"><i class="fa fa-plus" aria-hidden="true"></i></a></h4>
                  <div class="form-group row">
                    <div class="table-responsive col-md-12">
                      <table class="table table-striped mb-0">
                        <tbody>
                        <tr v-for="(task, index) in incident.tasks" :key="index">
                          <td>{{task.name }}</td>
                          <td>{{task.status}}</td>
                          <td>{{task.due_date}}</td>
                          <td>{{task.assigned_to_char}}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <!-- start attachments -->
                  <slot name="fileUpload"></slot>
                  <!-- end attachments -->
                  <!-- comments -->
                  <slot name="comments"></slot>
                  <!-- end comments -->
                </div> <!-- end col -->
              </div> <!-- end row-->
            </div> <!-- end card-body -->
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="border-0 btn btn-primary btn-gradient-primary btn-rounded" @click.prevent="saveIncident">Speichern</button>&nbsp;&nbsp;
          <button type="button" class="border-0 btn btn-warning btn-gradient-warning btn-rounded" @click.prevent="saveIncidentNoExit">Speichern und weiter bearbeiten</button>
          <button type="button" class="btn btn-secondary btn-rounded" @click="closeWarning('#'+objectModalName.incident)">Abbrechen</button>
        </div>

      </div><!-- modal-content -->
    </div><!-- modal-dialog -->
  </div><!-- modal -->
</template>

<script>
import {mapMutations, mapState} from 'vuex'
import service from '@/utils/request.js';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import dateTimePicker from 'vue-bootstrap-datetimepicker';
import { Uploader, Button } from 'vant';
import {closeWarning, ajaxErrorMessage} from '@/utils/index.js';
import {objectModalName} from "@/utils/enums";

  export default {
      name: "DKLIncident",
      components: {
        'van-uploader': Uploader,
        'van-button': Button,
        dateTimePicker,
      },
      props: {
        incident: {
          type: Object,
          required: true
        },
      },
      data() {
        return {
          datetimeOptions: {
            format: 'YYYY-MM-DD, h:mm',
            useCurrent: false,
            sideBySide: true,
          },
          dateOptions: {
            format: 'YYYY-MM-DD',
            useCurrent: false,
          },
          newComment: '',
          objectModalName: objectModalName
        }
      },
      validations() {
        return {
          incident: {
            datetime: {required, $lazy: true},
            description: {required, $lazy: true},
            reporter: {required, $lazy: true},
          },
        }
      },
      setup() {
        return {
          v$: useVuelidate()
        }
      },
      watch:{
        incident: {
          handler: function (newValue, oldVal) {
            if (!this.modalDirty) this.setModalDirty(true)
          },
          deep: true
        }
      },
      computed: {
        ...mapState({
          user: state => state.user,
          account: state => state.account,
          edit: state => state.app.edit,
          departments: state => state.account.departments,
          systems: state => state.account.systems,
          dataTypes: state => state.account.dataTypes,
          modalDirty: state => state.app.modalDirty,
        }),
      },
      mounted() {
        $(`#${objectModalName.incident}`).on('hidden.bs.modal', () => {
          this.setEdit(false)
        })
      },
      beforeDestroy() {
        $(`#${objectModalName.incident}`).off('hidden.bs.modal')
      },
      methods: {
        closeWarning,
        ...mapMutations({setEdit: 'SET_EDIT', setModalDirty: 'SET_MODALDIRTY'}),
        async saveIncident() {
          await this.saveIncidentNoExit()
          $('#' + objectModalName.incident).modal('hide')
        },
        async saveIncidentNoExit() {
          const isValid = await this.v$.incident.$validate()
          if (!isValid) {
            this.$vToastify.error('Bitte fehlende Felder vervollständigen!')
            return false
          }
          const newIncident = this.incident.id == null ? true : false
          let url = 'todos/v1/create_incident/'
          if (!newIncident) url = `todos/v1/update_incident/${this.incident.id}/`
          if (this.incident.customer == '') this.incident.customer = this.account.name
          this.incident.modified_by = this.user.username
          service.request({
            url: url,
            method: 'POST',
            responseType: 'json',
            data: this.incident
          }).then((response) => {
            this.setModalDirty(false)
            this.v$.$reset()
            this.$emit('incidentUpdated', response.data)
            this.$vToastify.success('Vorfall ist erfolgreich gespeichert!')
          }).catch(error => this.$vToastify.error(ajaxErrorMessage(error)))
        },
      }
    }
</script>

<style scoped>
.close {
  right: 25px;
  top: 20px;
}

</style>
